<div class="web-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-7 py-5">
        <p class="text-white link-casestudy">
          <span (click)="nav('/')">Home</span> /
          <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span>
        </p>
        <h1 class="py-3 saas-heading">
          End-to-end Custom Website Development for Cloud-Based Company
        </h1>
        <p class="py-3 saas-para">
          The client is a cloud service provider excelling in cloud consulting
          solutions that involve cloud monitoring and security services.
        </p>
        <div class="service-industry py-3">
          <div class="industry-box">
            <h6>Industry:<span class="ecommerce">Cloud services</span></h6>
          </div>
          <div class="service-box">
            <h6>Service:<span>Custom Web Development</span></h6>
          </div>
        </div>
      </div>

      <div class="col-md-5 pt-5">
        <img
          src="../../../../assets/resources/casestudies/web-development/web-dev.webp"
          class="img-fluid mobile-saas cross-mobile"
          alt="mobileimgs"
        />
      </div>
    </div>
  </div>
</div>
<!-- The challenge...................................................................... -->
<div class="challenge-background">
  <div class="container">
    <div class="row py-5">
      <div class="col-md-6">
        <h5 class="challenge-head">Objective</h5>
        <p class="py-3">
          The objective of the project is to design and develop an official
          website for a cloud-based company. This was an end-to-end custom
          website development involving design, development, testing, and
          hosting.
        </p>
      </div>

      <div class="col-md-6">
        <h5 class="challenge-head">The challenge</h5>
        <p class="py-3">
          The client wanted to create a unique website to have credibility and
          improve their visibility. Analyzing and finalizing color code and
          content for their services was quite challenging.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- The Solution................................................................................... -->
<div class="container">
  <div class="row">
    <div class="col-md-6 py-5">
      <h5 class="challenge-head">The solution</h5>
      <p class="py-4">
        We created the custom website with well-structured website architecture,
        user-friendly navigations, and easily understandable script for future
        development and maintenance. We also hosted the website in Azure which
        is a secure cloud environment.
      </p>
      <img
        src="../../../../assets/resources/casestudies/web-development/solution-platform.webp"
        alt="unified-solution"
        class="img-fluid"
      />
    </div>

    <div class="col-md-6 solution-background">
      <h5 class="text-white ps-md-3 ps-2 py-3">
        Our Approach 
      </h5>
      <div class="ps-md-5 ps-2 py-2 text-white">
        <ul>
          <li class="ico-img-sky">
            We created the wireframe with responsive User Interface and User Experience.
          </li>
          <li class="ico-img-sky">
            The content for the website was SEO-friendly to have better online visibility.
          </li>
          <li class="ico-img-sky">
            We planned the file structures for the complete website based on services.
          </li>
          <li class="ico-img-sky">
            Developed a compact and reusable code for maintenance and accessibility.
          </li>
          <li class="ico-img-sky">
            Responsive website with optimal performance and better loading speed.
          </li>
          <li class="ico-img-sky">
            Testing website in multiple browsers and devices to check the responsive.
          </li>
          <li class="ico-img-sky">
            Deployed the website on Azure platform for better security.
          </li>
          <li class="ico-img-sky">
            Total Duration to complete this end-to-end website was up to 3 weeks.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Outcome.............................................. -->
<div class="container">
  <div class="row">
    <div class="col-md-12 py-3">
      <h5 class="challenge-head">Outcome</h5>
      <ul>       
        <li class="ico-img-sky">User-friendly website with responsiveness.</li>
        <li class="ico-img-sky">Highly informative and SEO friendly content.</li>
        <li class="ico-img-sky">Achieved over 80% performance on both desktop and mobile devices.</li>
      </ul>
    </div>
  </div>
</div>
<!-- Technologies used.............................................. -->
<div class="container">
  <div class="row pb-4">
    <div class="col-md-8">
      <h5 class="challenge-head py-3">Technologies used</h5>
      <div class="row">      
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/angular-tech.png" class="img-fluid tech-icon" alt="angular"/>
      </div>      
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/aspdot-net.png" class="img-fluid tech-icon" alt="asp dotnwt "/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/html-tech.png" class="img-fluid tech-icon" alt="html"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/css-tech.png" class="img-fluid tech-icon" alt="css"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/azure-tech.png" class="img-fluid tech-icon" alt="azure"/>
      </div>
    </div>
    </div>
      <div class="col-md-4">

      </div>
  </div>
</div>